// Isotope
var Isotope = require('isotope-layout');

export default (function(window, document, undefined) {

  var iso, layoutHandler;
  var gridOptions = {}
  var fullWidthColumns = undefined;

  var calculateGridItemDimensions = function() {

    let $quarterElem = $('.individual-work--quarter:not(.individual-work--double)');
    let $doubleElem = $('.individual-work--double');
    let $halfElem = $('.individual-work--half');
    let $tallElem = $('.individual-work--tall');
    let $fullElem = $('.individual-work--full');
    let $workGrid = $('.work-container');

    let isHomeLanding = document.body.classList.contains('home-landing');
    let tallAspectRatio = isHomeLanding ? 1.21 : 1.041;

    let columnCount = fullWidthColumns ? 1 : 2;
    let spanMultiplier = 1; // the most a non full element can span
    let $firstQuarterElem = $quarterElem.first();
    let $firstTallElem = $tallElem.first();
    // let aspectRatio = (window.innerWidth / columnCount)//$firstTallElem.find('figure').data('aspect-ratio');

    if (columnCount == 1) {
      tallAspectRatio = 1;
    }

    let gridWidth = $workGrid.width();

    let tallWidth = Math.floor(gridWidth / columnCount);
    let tallDimensions = {
      width: tallWidth,
      height: Math.floor(tallWidth * tallAspectRatio),
    }

    let spannedDimensions = {
      height: tallDimensions.height * spanMultiplier,
      width: tallDimensions.width * spanMultiplier,
    };

    let tallHeight = spannedDimensions.height
    let halfHeight = tallDimensions.height / 2
    let fullHeight = Math.floor(spannedDimensions.height * .85)

    if (!isHomeLanding && window.outerWidth <= 680) {
      tallHeight = fullHeight = halfHeight
    } else if (isHomeLanding && window.outerWidth <= 680) {
      fullHeight = halfHeight = tallHeight
    }

    // the js-height-calculated classes removes the padding aspect ratio
    // $quarterElem.addClass('js-height-calculated').width(quarterDimensions.width).height(quarterDimensions.height);
    $fullElem.addClass('js-height-calculated').width(gridWidth).height(fullHeight);
    $halfElem.addClass('js-height-calculated').width(spannedDimensions.width).height(halfHeight);
    // $doubleElem.addClass('js-height-calculated').width(spannedDimensions.width).height(quarterDimensions.height);
    $tallElem.addClass('js-height-calculated').width(spannedDimensions.width).height(tallHeight);
  }

  var workUnveilHandler = function(e) {

    var workContainer = document.querySelector('.work-container')

    if (!workContainer) {
      return;
    }

    var isoOptions = {
      itemSelector: '.individual-work',
      percentPosition: false,
      transitionDuration: 0,
      stagger: 0,
      resize: false,
      masonry: {
        columnWidth: '.individual-work--tall',
      }
    }

    if (typeof gridOptions.filter !== 'undefined') {
      isoOptions.filter = gridOptions.filter
    }

    iso = new Isotope('.work-container', isoOptions);
    iso.on( 'layoutComplete', function( filteredItems ) {
      workContainer.classList.add('work-container--layout')
    });

    if (!layoutHandler) {
      layoutHandler = function() {
        calculateGridItemDimensions();
        iso.layout();
      };
    }

    layoutHandler();
  };

  var updateFullWidthColumns = function() {
    fullWidthColumns = true;

    if (document.documentElement.clientWidth > 680) {
      fullWidthColumns = false;
    }
  }

  function init(options) {

    gridOptions = { gridOptions, ...options }

    if (typeof fullWidthColumns == 'undefined') {
      updateFullWidthColumns();
    }

    calculateGridItemDimensions();
    workUnveilHandler();

    let layoutTimeout = null;
    window.addEventListener('optimizedResize', function() {
      updateFullWidthColumns();

      clearTimeout(layoutTimeout)
      layoutTimeout = setTimeout(() => {
        layoutHandler();
      }, 250)
    })
  }

  // ------------------------------
  // Public
  // ------------------------------

  return {
    init: init
  };

})(window, document);
